import React from "react";
import { Provider } from "react-redux";
import { store } from "./helpers";
import "./App.scss";
import { AppWrapper } from "./AppWrapper";

const App = (props) => {
  const { axiosErrorResponse } = props;

  return (
    <div>
      <Provider store={store}>
        <AppWrapper axiosErrorResponse={axiosErrorResponse} />
      </Provider>
    </div>
  );
};

export default App;
